import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import HomeViewTwo from '../views/HomeViewTwo.vue'
import DailyControlView from '../views/DailyControlView.vue'
import WeeklyInspectionView from '../views/WeeklyInspectionView.vue'
import MonthlyInspectionView from '../views/MonthlyInspectionView.vue'
import Login from '../views/login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { 
      requiresAuth: true,
      keepAlive: true // 启用keep-alive缓存
    }
  },
  {
    path: '/search/:id?',
    name: 'homeTwo',
    component: HomeViewTwo,
    meta: { requiresAuth: true }
  },
  {
    path: '/daily-control',
    name: 'dailyControl',
    component: DailyControlView,
    meta: { requiresAuth: true }
  },
  {
    path: '/weekly-inspection',
    name: 'weeklyInspection',
    component: WeeklyInspectionView,
    meta: { requiresAuth: true }
  },
  {
    path: '/monthly-inspection',
    name: 'monthlyInspection',
    component: MonthlyInspectionView,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { guest: true }
  },
  {
    path: '*',
    redirect: '/login'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫 - 登录验证
router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('token')
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 需要登录的页面
    if (!isAuthenticated) {
      next({ path: '/login', query: { redirect: to.fullPath } })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    // 游客页面（登录页）
    if (isAuthenticated) {
      next({ path: '/' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
